import { BinaryWriter } from "../binary.js";
import { ServerOp } from "../opcodes.js";
/**
 * Natureza da mensagem, para o cliente escolher cor e posição sem interpretar o texto.
 *
 * A alternativa — mandar a cor no pacote — deixaria a identidade visual do jogo
 * espalhada pelo servidor, e mudar o tom de vermelho dos erros viraria uma alteração
 * de backend.
 */
export const MessageKind = {
    /** Curiosidade sem consequência: "você vê uma espada." */
    Info: 0,
    /** Recusa da ação pedida: mana insuficiente, longe demais, sem capacidade. */
    Warn: 1,
    /** Ganho: experiência, avanço de skill, item recebido. */
    Advance: 2,
    /** Perda relevante: morte, experiência perdida, item caído. */
    Loss: 3,
};
export function encodeServerMessage(packet, writer = new BinaryWriter(64)) {
    writer.u8(ServerOp.ServerMessage).u8(packet.kind).str8(packet.text);
    return writer;
}
export function decodeServerMessage(reader) {
    const rawKind = reader.u8();
    const kind = rawKind === MessageKind.Warn ||
        rawKind === MessageKind.Advance ||
        rawKind === MessageKind.Loss
        ? rawKind
        : MessageKind.Info;
    return { kind, text: reader.str8() };
}
//# sourceMappingURL=server-message.js.map